<template lang="pug">
  .product-info
    img.product-info__title-image( v-if="titleImage" :src="titleImage" :alt="product.title")
    h1.product-info__title(:class="titleImage ? 'u-sr-only' : ''") {{ product.title }}
    .product-info__type-antioxidants
      .product-info__type-antioxidant(v-if="product.customFields.flavor_type")
        .product-info__icon
          icon(name='leaf' size="18px")
        span.product-info__icon-text {{ product.customFields.flavor_type }}
      .product-info__type-antioxidant(v-if="product.customFields.antioxidants")
        .product-info__icon
          icon(name='antioxidant' size="18px")
        span.product-info__icon-text {{ product.customFields.antioxidants }}mg Antioxidants
    .product-info__description(
      v-if="product.description"
      v-html="product.description"
    )
    svg.product-info__properties
      use(xmlns:xlink="http://www.w3.org/1999/xlink", href="#properties")
</template>

<script>
  import ProductReviewSummary from 'scripts/components/product/ProductReviewSummary.vue';
  import Icon from '../basic/Icon.vue';

  export default {
    name: 'ProductDisplay',
    components: { ProductReviewSummary, Icon },
    props: {
      product: Object,
      titleImage: String,
    },
    computed: {},
  };
</script>

<style lang="scss">
  .product-info {
  }

  .product-info__title-image {
    margin-bottom: 32px;
    width: 200px;
  }

  .product-info__pre-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .product-info__category-heading {
    color: $color-black;
    font-size: rem(16);
    font-weight: $font-weight-regular;
    line-height: rem(20);
    letter-spacing: 0.79px;
    text-transform: uppercase;
    margin-bottom: 0;

    @include tablet-up {
      font-size: rem(18);
      line-height: rem(23);
    }
  }

  .product-info__title {
    color: $color-black;
    font-size: rem(48);
    font-weight: 500;
    line-height: rem(55);
    margin-bottom: 32px;
  }

  .product-info__type-antioxidants {
    margin-bottom: 30px;
  }

  .product-info__type-antioxidants,
  .product-info__type-antioxidant {
    display: flex;
    align-items: center;
  }

  .product-info__type-antioxidant {
    margin-right: 20px;

    @include tablet-up {
      margin-right: 64px;
    }
  }

  .product-info__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    margin-right: 10px;
    border-radius: 50px;
    background-color: black;
    background-color: var(--pdp-color);
    width: 30px;
    height: 30px;
  }

  .product-info__icon-text {
    font-family: $font-secondary;
    font-weight: 700;
    text-transform: capitalize;
  }

  .product-info__description {
    margin-bottom: ($spacing-unit * 5);
    color: $color-black;
    font-size: $font-size-body;
    font-family: $font-secondary;
    font-weight: $font-weight-regular;

    p {
      margin-top: 0;
    }
  }

  .product-info__properties {
    margin-bottom: 30px;
    height: 93px;
    width: 100%;

    @include tablet-up {
      width: 480px;
    }
  }

  .chemicals-color {
    fill: var(--pdp-color);
  }
</style>
